const policies = [{
  version: 1,
  title: "Privacy Policy",
  introduction:
    "Genomatics Pvt Ltd is committed to safeguarding your privacy. Contact us at contact@genomatics.in if you have any questions or problems regarding the use of your Personal Data and we will gladly assist you.",
  consentMessage:
    "By using this site or/and our services, you consent to the Processing of your Personal Data as described in this Privacy Policy.",
  tableOfContents: [
    { title: "Definitions used in this Policy", link: "#definitions" },
    { title: "Data protection principles we follow", link: "#data-protection-principles" },
    { title: "What rights do you have regarding your Personal Data", link: "#data-subject-rights" },
    { title: "What Personal Data we gather about you", link: "#data-we-gather" },
    { title: "How we use your Personal Data", link: "#how-we-use-data" },
    { title: "Who else has access to your Personal Data", link: "#who-can-access" },
    { title: "How we secure your data", link: "#how-we-secure-data" },
    { title: "Information about cookies", link: "#cookies-and-technologies" },
    { title: "Contact information", link: "#contact-information" },
    { title: "Changes to this Privacy Policy", link: "#changes-to-policy" }
  ],
  sections: {
    definitions: [
      { term: "Personal Data", definition: "Any information relating to an identified or identifiable natural person." },
      { term: "Processing", definition: "Any operation or set of operations which is performed on Personal Data or on sets of Personal Data." },
      { term: "Data subject", definition: "A natural person whose Personal Data is being Processed." },
      { term: "Child", definition: "A natural person under 16 years of age." },
      { term: "We/us", definition: "Genomatics Pvt Ltd." }
    ],
    dataProtectionPrinciples: [
      "Processing is lawful, fair, and transparent. Our Processing activities have lawful grounds. We always consider your rights before Processing Personal Data. We will provide you information regarding Processing upon request.",
      "Processing is limited to the purpose. Our Processing activities fit the purpose for which Personal Data was gathered.",
      "Processing is done with minimal data. We only gather and Process the minimal amount of Personal Data required for any purpose.",
      "Processing is limited with a time period. We will not store your personal data for longer than needed.",
      "We will do our best to ensure the accuracy of data.",
      "We will do our best to ensure the integrity and confidentiality of data."
    ],
    dataSubjectRights: {
      "Right to information":
        "Meaning you have the right to know whether your Personal Data is being processed; what data is gathered, from where it is obtained and why and by whom it is processed.",
      "Right to access":
        "Meaning you have the right to access the data collected from/about you. This includes your right to request and obtain a copy of your Personal Data gathered.",
      "Right to rectification":
        "Meaning you have the right to request rectification or erasure of your Personal Data that is inaccurate or incomplete.",
      "Right to erasure":
        "Meaning in certain circumstances you can request for your Personal Data to be erased from our records.",
      "Right to restrict processing":
        "Meaning where certain conditions apply, you have the right to restrict the Processing of your Personal Data.",
      "Right to object to processing":
        "Meaning in certain cases you have the right to object to Processing of your Personal Data, for example in the case of direct marketing.",
      "Right to object to automated processing":
        "Meaning you have the right to object to automated Processing, including profiling; and not to be subject to a decision based solely on automated Processing. This right you can exercise whenever there is an outcome of the profiling that produces legal effects concerning or significantly affecting you.",
      "Right to data portability":
        "You have the right to obtain your Personal Data in a machine-readable format or if it is feasible, as a direct transfer from one Processor to another.",
      "Right to lodge a complaint":
        "In the event that we refuse your request under the Rights of Access, we will provide you with a reason as to why. If you are not satisfied with the way your request has been handled please contact us.",
      "Right for the help of supervisory authority":
        "Meaning you have the right for the help of a supervisory authority and the right for other legal remedies such as claiming damages.",
      "Right to withdraw consent":
        "You have the right withdraw any given consent for Processing of your Personal Data."
    },
    dataWeGather: [
      "[TODO] - Information you have provided us with: This might be your e-mail address, name, billing address, home address etc – mainly information that is necessary for delivering you a product/service or to enhance your customer experience with us.",
      "[TODO] - Information automatically collected about you: This includes information that is automatically stored by cookies and other session tools. For example, your shopping cart information, your IP address, your shopping history (if there is any) etc. This information is used to improve your customer experience.",
      "[TODO] - Information from our partners: We gather information from our trusted partners with confirmation that they have legal grounds to share that information with us.",
      "Publicly available information: We might gather information about you that is publicly available."
    ],
    howWeUseData: [
      "We use your Personal Data to provide our service to you, enhance your customer experience, and fulfill an obligation under law or contract.",
      "We process your Personal Data on legitimate grounds and/or with your consent."
    ],
    whoCanAccessData: [
      "We do not share your Personal Data with strangers. Personal Data about you is provided to trusted partners in order to either make providing the service to you possible or to enhance your customer experience.",
      "We share your data with processing partners, business partners, and connected third parties.",
      "We disclose your Personal Data to third parties or public officials when we are legally obliged to do so."
    ],
    howWeSecureData: [
      "We use safe protocols for communication and transferring data (such as HTTPS). We use anonymising and pseudonymising where suitable. We monitor our systems for possible vulnerabilities and attacks.",
      "We cannot guarantee the security of information but will notify authorities and you if there is a threat to your rights or interests."
    ],
    children: [
      "We do not intend to collect or knowingly collect information from children. We do not target children with our services."
    ],
    cookiesAndTechnologies: [
      "We use cookies and/or similar technologies to analyze customer behavior, administer the website, track users' movements, and to collect information about users in order to personalize and enhance your experience with us.",
      "We use cookies for purposes such as necessary cookies, functionality cookies, analytics cookies, and advertising cookies."
    ],
    contactInformation: {
      supervisoryAuthority: "contact@genomatics.in"
    },
    changesToPolicy: [
      "We reserve the right to make changes to this Privacy Policy.",
      "Last modification was made Dec 5, 2018."
    ]
  }
}];

const privacyPolicyData = policies[policies.length - 1];
  
export default privacyPolicyData;